document.addEventListener('click', function (e) {
    if (
      e.target.classList.contains('quantity-btn-plus') ||
      e.target.classList.contains('quantity-btn-minus')
    ) {
      e.preventDefault();

      const quantityBox = e.target.closest('.quantity');
      console.log(quantityBox);
      if (!quantityBox) return;

      const input = quantityBox.querySelector('input[name="updates[]"]');
      if (!input) return;

      let value = parseInt(input.value, 10) || 1;

      if (e.target.classList.contains('quantity-btn-plus')) {
        value += 1;
      } else {
        value = Math.max(1, value - 1);
      }

      input.value = value;

      // Let theme / Shopify detect the change
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
